import { render, staticRenderFns } from "./DialogDetalhesTermoPolitica.vue?vue&type=template&id=505fa4e9&"
import script from "./DialogDetalhesTermoPolitica.vue?vue&type=script&lang=js&"
export * from "./DialogDetalhesTermoPolitica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports